export function toPrettyJson(input: object | undefined): string {
  return JSON.stringify(input, null, 2);
}

export function tryParseJson(input: string | undefined, log = false): object | undefined {
  if (!input) {
    return;
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(input);
  } catch (e) {
    if (log) {
      console.warn('tryParseJson failed', e);
    }

    return;
  }
}

/**
 * This is absolutely not the prettiest solution to highlight a JSON document.
 * It works fine for the Chat POC, for further use of this function, consider looking into different alternatives.
 */
export function toHighlightedJson(json: string) {
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
    function (match) {
      let cls = 'number';
      if (match.startsWith('"')) {
        if (match.endsWith(':')) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (match.includes('null')) {
        cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    }
  );
}
